import { render, staticRenderFns } from "./BookingLogEntryContent.vue?vue&type=template&id=2378e4f2"
import script from "./BookingLogEntryContent.vue?vue&type=script&lang=ts"
export * from "./BookingLogEntryContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports